export default function AppEntry() {
  return (
    <section id="app" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            吃瓜快报入口
          </h2>
        </div>
        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-background-900 to-background-800 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/10 rounded-full -translate-y-1/2 translate-x-1/4 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-500/10 rounded-full translate-y-1/3 -translate-x-1/4 blur-3xl"></div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-400 text-xs font-medium mb-4 whitespace-nowrap">
                随时随地吃瓜
              </span>
              <h3 className="text-2xl md:text-3xl font-heading text-white mb-3">
                51吃瓜黑料 · 手机端直达
              </h3>
              <p className="text-sm text-background-400 max-w-md leading-relaxed">
                访问51吃瓜黑料网址入口即可在手机上随时浏览最新网曝门爆料与网红塌房黑料，界面适配移动端，吃瓜快人一步。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 mt-6 justify-center lg:justify-start">
                <button className="whitespace-nowrap px-6 py-2.5 rounded-full bg-accent-500 text-white text-sm font-semibold hover:bg-accent-600 transition-colors duration-200 cursor-pointer shadow-lg shadow-accent-500/30">
                  <i className="ri-smartphone-line mr-2"></i>
                  手机访问入口
                </button>
                <button className="whitespace-nowrap px-6 py-2.5 rounded-full border border-white/20 text-white text-sm font-medium hover:bg-white/10 transition-colors duration-200 cursor-pointer">
                  <i className="ri-qr-code-line mr-2"></i>
                  扫码直达
                </button>
              </div>
            </div>
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-background-700 flex items-center justify-center">
              <i className="ri-smartphone-line text-6xl text-background-400"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}